export class ProductCondition {
  constructor(
    technicalId,
    productBoomerangId,
    conditionTitle,
    conditionDetail,
    conditionOrder
  ) {
    this.technicalId = technicalId
    this.productBoomerangId = productBoomerangId
    this.conditionTitle = conditionTitle
    this.conditionDetail = conditionDetail
    this.conditionOrder = conditionOrder
  }
}
